module.exports = __webpack_public_path__ + "img/clockwise.6ffe9ba3.gif";